import { useEffect, useState, type RefObject } from "react";

/** True from the first moment `threshold` of the element has been on screen, and for good after. */
export function useArrived(ref: RefObject<Element | null>, threshold = 0.3) {
  const [arrived, setArrived] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el || arrived) return;
    if (typeof IntersectionObserver === "undefined") {
      setArrived(true);
      return;
    }
    const io = new IntersectionObserver(
      (entries) => {
        if (entries.some((e) => e.isIntersecting)) {
          setArrived(true);
          io.disconnect();
        }
      },
      { threshold }
    );
    io.observe(el);
    return () => io.disconnect();
  }, [ref, threshold, arrived]);
  return arrived;
}
